var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{staticStyle:{"margin-top":"30px"},attrs:{"bottom":"","value":_vm.visible,"timeout":_vm.timeout,"color":_vm.color,"left":""}},[_vm._v(" "+_vm._s(_vm.message)+" "),(_vm.dismissable)?_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v(" x ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }